import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import VueContextMenu from 'vue-contextmenu'
import ace from 'ace-builds'
import 'vue-contextmenu/style/css/font-awesome.min.css'

Vue.use(VueContextMenu);
Vue.use(ace);
//import { Button, Select } from 'element-ui'
// 引用API文件 //在线咨询 》

import api from './api/$ajax.js'
// 将API方法绑定到全局

Vue.prototype.$api = api
Vue.config.productionTip = false
Vue.config.Debug = true
Vue.use(ElementUI)
// 引用工具文件
import 'element-ui/lib/theme-chalk/index.css'
import utils from './utils/index.js'
import directive from './utils/directive.js'
// 将工具方法绑定到全局
Vue.prototype.$utils = utils
/*import lodash from 'lodash'
import VueLodash from 'vue-lodash'

Vue.use(VueLodash, lodash)
	console.log(Vue._.random(20));
*/
router.afterEach((to, from) => {  //刷新时清除本地数据
  console.log(to)
	var type = getQuery("type");
	var version_id = type == 1 ? getQuery("pc_version_id") : getQuery("mobile_version_id");
	if(!to.params.param.endsWith(version_id + "000")) {
		var pc_version_id = getQuery("pc_version_id")
		localStorage.removeItem(pc_version_id + "000");
		console.log("sf_st")
		var mobile_version_id = getQuery("mobile_version_id")
		localStorage.removeItem(mobile_version_id + "000");

		localStorage.removeItem(to.params.param);
	}
	// debugger;
})
/* eslint-disable no-new */
// 配置百度编辑器
import '../static/ue/ueditor.config.js'
import '../static/ue/ueditor.all.min.js'
import '../static/ue/lang/zh-cn/zh-cn.js'
import '../static/ue/ueditor.parse.min.js'
import store from './vuex/store'

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',
	components: {
		App
	}
})



// WEBPACK FOOTER //
// ./src/main.js